import React, { useState, useEffect } from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import * as API from '../utility/api'
import GlobalLoadingIndicator from '../components/global-loading-indicator'
import { signOut } from '../actions/users'

Modal.setAppElement('#root')

const customStyles = {
  content: {
    top: '40%',
    left: '50%',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    minWidth: '320px',
    maxWidth: '700px',
    padding: '10px 20px 20px 20px'
  }
}

const AdditionalInfoModal = ({ signedIn, userInfo, dispatch }) => {
  const [open, setOpen] = useState(false)
  const [phonenumber, setPhonenumber] = useState(
    (userInfo && userInfo['custom:phone_number']) || ''
  )
  const [allowMarketing, setAllowMarketing] = useState(
    (userInfo && userInfo['custom:allow_marketing']) || false
  )
  const [shake, setShake] = useState(false)
  const [fetching, setFetching] = useState(false)
  const [error, setError] = useState(false)
  const [logout, setLogout] = useState(false)

  useEffect(() => {
    const tel = (userInfo && userInfo['custom:phone_number']) || false

    if (signedIn && !tel) {
      setOpen(true)
    }
  }, [signedIn, userInfo])

  useEffect(() => {
    const timeout = setTimeout(() => setShake(false), 820)

    return () => clearTimeout(timeout)
  }, [shake])

  const handleSubmit = e => {
    e.preventDefault()

    if (logout) {
      dispatch(signOut())
      setOpen(false)
      return
    }

    setFetching(true)

    API.POST('auth', {
      action: 'update_additional_info',
      phonenumber,
      allowMarketing
    })
      .then(() => {
        setOpen(false)
      })
      .catch(e => {
        setFetching(false)
        setError(true)
        console.log(e);
      })
  }

  const validateInput = () => {
    return phonenumber !== ''
  }

  return (
    <Modal
      isOpen={open}
      onRequestClose={() => setShake(true)}
      style={customStyles}
      contentLabel="Login Modal"
    >
      <div className={shake ? 'shake' : ''}>
        <h1>
          <Translate value="additional_info_form.update_information" />
        </h1>

        <div>
          <Translate value="additional_info_form.info_missing" />
        </div>

        <div className="break-md" />
        <form onSubmit={handleSubmit}>
          <div>
            <label htmlFor="tel">
              <Translate value="user.phone_number" />
            </label>

            <input
              type="number"
              id="tel"
              value={phonenumber}
              onChange={e => {
                setPhonenumber(e.target.value)
              }}
              className="user-info"
              autoComplete="tel"
            />
          </div>
          <div className="break-lg" />
          <div className="check-terms-container">
            <label htmlFor="marketing-input">
              <input
                id="marketing-input"
                type="checkbox"
                checked={allowMarketing}
                onChange={e => {
                  setAllowMarketing(e.target.checked)
                }}
              />
              <Translate value="registration.confirm_marketing_licence" />
            </label>
          </div>

          <div className="break-lg" />

          {!fetching && (
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                <button disabled={!validateInput()} type="submit">
                  <Translate value="additional_info_form.save" />
                </button>

                <button onClick={() => setLogout(true)}>
                  <Translate value="additional_info_form.logout" />
                </button>
              </div>
            </div>
          )}

          {fetching && (
            <div style={{ justifyContent: 'center', display: 'flex' }}>
              <GlobalLoadingIndicator />
            </div>
          )}

          {error && (
            <div className="error-message">
              <div className="break-md"></div>
              <div>
                <Translate value="user_page.info.user_info_update_failed" />
              </div>
            </div>
          )}
        </form>
      </div>
    </Modal>
  )
}

const mapStateToProps = state => {
  return {
    signedIn: state.users.signedIn,
    userInfo: state.users.userInfo
  }
}

export default connect(mapStateToProps)(AdditionalInfoModal)
